import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {fetchAllUsers} from "../components/Users/UsersApi";

const initialState = {
    allUsers: [],
    appLoader: false,
    isLoading: false,
    pagination: {
        currentPage: 0,
        total: 0,
        pageSize: 0,
    }
}

export const getAllUsers = createAsyncThunk(
    '/users/fetch',
    async ({page = 0, pageSize = 10, usersId = "", search = ""}) => {
        try {
            const response = await fetchAllUsers(page, pageSize, usersId, search)
            return response.data
        } catch (err) {
            console.log(err)
        }
    }
)

export const usersData = createSlice({
    name: "users",
    initialState,
    extraReducers: builder => {
        builder
            .addCase(getAllUsers.pending, (state) => {
                state.allUsers = [];
                state.isLoading = true;
                state.appLoader = true;
            })
            .addCase(getAllUsers.rejected, (state, action) => {
                state.isLoading = false;
                state.allUsers = [];
                state.appLoader = false;
            })
            .addCase(getAllUsers.fulfilled, (state, action) => {
                const {content, totalElements, size, number} = action.payload;
                state.isLoading = false;
                state.allUsers = content;
                state.appLoader = false;
                state.pagination.total = totalElements;
                state.pagination.pageSize = size;
                state.pagination.currentPage = number;
            })
    }
})

export const {openDeleteModal, closeDeleteModal} = usersData.actions
export default usersData.reducer;